// libs
import { Link } from "react-router-dom";
import styled from "styled-components";
import { motion } from "framer-motion";
// components
import { fill } from "../styles/utils";
import { Box } from "./Box";
import { Chip } from "./Chip";
import { FlexContainer, FlexItem } from "./Flex";
import { ImageFill } from "./ImageFill";
import { Text } from "./Text";
// other
import { ImageConfig } from "../models/client";

interface SearchItemProps {
  link: string;
  image: ImageConfig;
  title: string;
  tags: string[];
}

const ImgContainer = styled(motion.div)`
  position: relative;
  padding-top: 140%;
  box-shadow: ${({ theme }) => theme.shadows[1]};
  cursor: pointer;
`;

const StretchedLink = styled(Link)`
  &::after {
    content: "";
    ${fill()};
  }
`;

export const SearchItem: React.FC<SearchItemProps> = ({
  link,
  image,
  title,
  tags,
}) => {
  return (
    <Box position="relative">
      <ImgContainer>
        <ImageFill src={`${image.src}?width=500`} alt={image.title} />
      </ImgContainer>
      <Box mt={3}>
        <Text variant="h5" lineHeight={1.2}>
          <StretchedLink to={link}>{title}</StretchedLink>
        </Text>
      </Box>
      <Box mt={2}>
        <FlexContainer>
          <FlexItem>
            {tags.map((tag) => (
              <Chip key={tag} color="melon">
                {tag}
              </Chip>
            ))}
          </FlexItem>
        </FlexContainer>
      </Box>
    </Box>
  );
};
